import { GoogleMapsEnvironment } from 'src/environments/environment';

export const GoogleMapsEnv = {
  key: Object.prototype.hasOwnProperty.call(GoogleMapsEnvironment, 'key')
    ? GoogleMapsEnvironment.key
    : null,
  faqUrl: Object.prototype.hasOwnProperty.call(GoogleMapsEnvironment, 'faqUrl')
    ? GoogleMapsEnvironment.faqUrl
    : '/#',
};
